<template>
<div class="body">
  <div class="title" >
   <template v-if="type === 0">

    <Administrator></Administrator>

   </template>
   <template v-else>

      <DomesticConsumer></DomesticConsumer>

   </template>
  </div>
</div> 

</template>

<script>
import countTo from 'vue-count-to'
import { shouyeshuju, adminInfo } from '@/api/login'
import DomesticConsumer from './components/DomesticConsumer.vue'
import Administrator from './components/Administrator.vue'


import adminIndexImage from '@/assets/admin-index.png'
import pageEmpty from '@/assets/page-empty.png'


export default {
  name: 'index',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    countTo,
    DomesticConsumer,
    Administrator
  },
  data () {
    return {
      adminIndexImage,
      pageEmpty,
      durationTime: '1500',
      xiehuishuju: [
        {
          title: '社团组织',
          img: require('../../assets/img/ho.png'),
          num: '',
          add: ''
        },

      ],
      fabushuju: [
        {
          num: '',
          title: '总发布'
        }
      ],
      shujuList: [
        {
          num: '',
          title: '二手转让'
        },
        {
          num: '',
          title: '人才招聘'
        },
        {
          num: '',
          title: '房产中介'
        },
        {
          num: '',
          title: '批发导购'
        },
        {
          num: '',
          title: '招商加盟'
        },
        {
          num: '',
          title: '求租求购'
        }
      ],
      daibanshixiang: [
        {
          ims: require('../../assets/img/daichuli.png'),
          title: '待处理社团申请',
          nmss: ''
        },
        {
          ims: require('../../assets/img/daishouli.png'),
          title: '待受理帖子举报',
          nmss: ''
        },
        {
          ims: require('../../assets/img/daishoulidianpu.png'),
          title: '待审核店铺申请',
          nmss: ''
        },
        {
          ims: require('../../assets/img/daishenhe.png'),
          title: '待审核身份证信息',
          nmss: ''
        },
        {
          ims: require('../../assets/img/daidakuan.png'),
          title: '待打款提现申请',
          nmss: ''
        },
        {
          ims: require('../../assets/img/daishouliyijian.png'),
          title: '待受理意见反馈',
          nmss: ''
        },
        {
          ims: require('../../assets/img/daishoulimingpian.png'),
          title: '待审核名片资料',
          nmss: ''
        }
      ],
      zhucerenshu: '',
      todayzhuce: '',
      Querydscff: {},
      type: 1,
    }
  },
  created () {
    this.xiangqing()
  },
  methods: {
    xiangqing () {
      const obj = {
        token: sessionStorage.getItem('token')
      }

      adminInfo(obj).then(({ data: res }) => {
        console.log('res', res)
        this.type = res.type
        this.Title =res
        if (res.type !== 2) {
           shouyeshuju(obj).then(({ data: res }) => {
          console.log('rescc', res)
          this.xiehuishuju[0].num = res.association_count
          this.xiehuishuju[0].add = res.association_monthcount
          // this.xiehuishuju[1].num = res.business_count
          // this.xiehuishuju[1].add = res.business_monthcount
          this.zhucerenshu = res.usercardcount
          this.todayzhuce = res.todayusercardcount
          this.Querydscff = res
          this.fabushuju[0].num = res.posttotalcount
          this.shujuList[0].num = res.secondhandtotalcount
          this.shujuList[1].num = res.jobcount
          this.shujuList[2].num = res.houseagentcount
          this.shujuList[3].num = res.supplydemandcount
          this.shujuList[4].num = res.attractinvestmentcount
          this.shujuList[5].num = res.leasecount
          this.daibanshixiang[0].nmss = res.applybusinessassociationcount
          this.daibanshixiang[1].nmss = res.applytipscount
          this.daibanshixiang[3].nmss = res.applyidcardcount
          this.daibanshixiang[3].nmss = res.applyidcardcount
          this.daibanshixiang[5].nmss = res.applyidcardcount
          this.daibanshixiang[6].nmss = res.applyusercardcount
      })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">


</style>
